import { useClient } from "@/composables/useClient";
import { deserializeCbiDto, serializeCbiDto, encodeRequestParam } from "../serialization/CbiDateCodec";
import type { PurchaseDeliveryApi } from "../../api/PurchaseDeliveryApi";
import type { AddressStaff } from "../../generated/dto/AddressStaff";
import type { PersonFetchOptions } from "../../generated/dto/PersonFetchOptions";
import type { PersonStaff } from "../../generated/dto/PersonStaff";
import type { PurchaseDeliveryFetchOptions } from "../../generated/dto/PurchaseDeliveryFetchOptions";
import type { PurchaseDeliveryStaff } from "../../generated/dto/PurchaseDeliveryStaff";

export class PurchaseDeliveryApiClient implements PurchaseDeliveryApi {
  constructor(private readonly client = useClient()) {}

  async getPurchaseDeliveryStaff(id: number, options?: PurchaseDeliveryFetchOptions): Promise<PurchaseDeliveryStaff> {
    const { data } = await this.client.get<unknown>(`/purchasedelivery/staff/${id}`, { params: serializeCbiDto(options, "generated.dto.PurchaseDeliveryFetchOptions") });
    return deserializeCbiDto<PurchaseDeliveryStaff>(data, "generated.dto.PurchaseDeliveryStaff");
  }

  async getPurchaseDeliveryStaffTargetPerson(id: number, options?: PersonFetchOptions): Promise<PersonStaff | null> {
    const { data } = await this.client.get<unknown>(`/purchasedelivery/staff/${id}/targetperson`, { params: serializeCbiDto(options, "generated.dto.PersonFetchOptions") });
    return deserializeCbiDto<PersonStaff | null>(data, "generated.dto.PersonStaff");
  }

  async getPurchaseDeliveryStaffTargetAddress(id: number): Promise<AddressStaff | null> {
    const { data } = await this.client.get<unknown>(`/purchasedelivery/staff/${id}/targetaddress`);
    return deserializeCbiDto<AddressStaff | null>(data, "generated.dto.AddressStaff");
  }
}

export const usePurchaseDeliveryApi = (): PurchaseDeliveryApi => new PurchaseDeliveryApiClient();
